import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * @slot - the slot which holds the accordion-items
 */
@Component({
  tag: 'wb-accordion',
  styleUrl: 'accordion.scss',
  shadow: true,
})
export class AccordionComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * The colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme | 'grey';

  /** If present, uses the subtle variant of the accordion */
  @Prop({ reflect: true })
  public subtle?: boolean;

  /** prevents mobile flyout behavior if present */
  @Prop({ reflect: true })
  public preventMobileFlyout: boolean = false;

  public render(): JSX.Element {
    return (
      <Host class="wb-accordion" data-on={getDataOnFromTheme(this.el, this.theme === 'grey' ? undefined : this.theme)}>
        <slot />
      </Host>
    );
  }
}
